<template>
  <span class="scaling-svg-container">
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" class="scaling-svg">
      <g id="Group_60" data-name="Group 60" transform="translate(-1838 -200)">
        <path
          d="M10.5,15h-7a2.028,2.028,0,0,1-2.1-2.045V4.091H.7A.654.654,0,0,1,0,3.409a.654.654,0,0,1,.7-.682H3.5V2.045A2.028,2.028,0,0,1,5.6,0H8.4a2.028,2.028,0,0,1,2.1,2.045v.682h2.8a.654.654,0,0,1,.7.682.654.654,0,0,1-.7.682h-.7v8.864A2.028,2.028,0,0,1,10.5,15ZM2.8,4.091v8.864a.655.655,0,0,0,.7.682h7a.654.654,0,0,0,.7-.682V4.091ZM5.6,1.364a.654.654,0,0,0-.7.682v.682H9.1V2.045a.654.654,0,0,0-.7-.682ZM8.4,11.591a.654.654,0,0,1-.7-.682V6.818a.654.654,0,0,1,.7-.682.654.654,0,0,1,.7.682v4.091A.654.654,0,0,1,8.4,11.591Zm-2.8,0a.654.654,0,0,1-.7-.682V6.818a.654.654,0,0,1,.7-.682.654.654,0,0,1,.7.682v4.091A.654.654,0,0,1,5.6,11.591Z"
          transform="translate(1838 200)"
        />
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class RemoveIcon extends Vue {}
</script>

<style>
</style>
